import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { createRoot } from "react-dom/client";
import type { Articles } from "./types";
import ArticleCard from "./ArticleCard";
import Pagination from "./Pagination";

const containerAll = document.querySelector('[data-id=container]');
if (!containerAll) throw new Error('Container element not found');
const root = createRoot(containerAll);

root.render(<Blog />);


function Blog() {
    const apiUrl = import.meta.env.VITE_API_URL || 'https://localhost';
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    const [articles, setArticles] = useState<Articles>([]);
    const [totalArticles, setTotalArticles] = useState<number>(0);

    const articlesPerPage = 10;
    const totalPages = useMemo(() => Math.ceil(totalArticles / articlesPerPage), [totalArticles]);
    const [currentPage, setCurrentPage] = useState<number>(1);

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const res = await axios.get(`${apiUrl}/api/blog/articles`, {
                    params: {
                        limit: articlesPerPage,
                        page: currentPage,
                    },
                });

                const data: Articles = res.data;
                setTotalArticles(Number(res.headers['x-total-count']));

                setArticles(data
                    .toSorted((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                );
            }
            catch (error: any) {
                setError(true);
            }
            finally {
                setLoading(false);
            }
        };

        fetchArticles();
    }, [currentPage]);

    if (loading) {
        return <p className="text-informative loading">Chargement</p>;
    }

    if (error) {
        return <p className="text-informative error">Une erreur est survenue pendant le chargement. Veuillez réessayer plus tard.</p>;
    }

    if (articles.length === 0) {
        return <p className="italic text-gray-600">Aucun article publié pour le moment.</p>;
    }

    return (
        <div className="flex flex-col gap-2 w-full">
            {
                articles.map((article, index) => {
                    return <>
                        <ArticleCard key={index} article={article} />
                        {index < articles.length - 1 && <hr className="my-8 border-gray-200 min-w-36 max-w-48 mx-auto" />}
                    </>;
                })
            }
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page: number) => { setCurrentPage(page); }}
            />
        </div>
    );
}